import { __decorate } from "tslib";
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { action, computed, observable, runInAction } from 'mobx';
import defaultTo from 'lodash/defaultTo';
import noop from 'lodash/noop';
import xor from 'lodash/xor';
import isNil from 'lodash/isNil';
import C7NTree, { TreeNode, } from 'choerodon-ui/lib/tree';
import autobind from '../_util/autobind';
import { getKey, getTreeNodes } from './util';
import { BooleanValue, DataSetEvents, DataSetSelection } from '../data-set/enum';
import Spin from '../spin';
export function defaultRenderer({ text }) {
    return text;
}
function defaultNodeCover() {
    return {};
}
function getCheckedKeys(checkedKeys) {
    return Array.isArray(checkedKeys)
        ? checkedKeys
        : typeof checkedKeys === 'object'
            ? checkedKeys.checked
            : [];
}
let Tree = class Tree extends Component {
    constructor(props, context) {
        super(props, context);
        this.inCheckExpansion = false;
        runInAction(() => {
            this.stateCheckedKeys = [];
            this.stateExpandedKeys = [];
            this.stateLoadedKeys = [];
        });
    }
    componentWillMount() {
        this.handleDataSetLoad();
        this.processDataSetListener(true);
    }
    componentWillReceiveProps(nextProps) {
        const { defaultExpandAll, defaultSelectedKeys, defaultExpandedKeys, defaultCheckedKeys } = this.props;
        if (defaultExpandAll !== nextProps.defaultExpandAll ||
            defaultExpandedKeys !== nextProps.defaultExpandedKeys ||
            defaultCheckedKeys !== nextProps.defaultCheckKeys ||
            defaultSelectedKeys !== nextProps.defaultSelectedKeys) {
            this.processDataSetListener(false);
            this.processDataSetListener(true);
        }
    }
    componentWillUnmount() {
        this.processDataSetListener(false);
    }
    processDataSetListener(flag) {
        const { dataSet, selectable, checkable } = this.props;
        if (dataSet) {
            const handler = flag ? dataSet.addEventListener : dataSet.removeEventListener;
            handler.call(dataSet, DataSetEvents.load, this.handleDataSetLoad);
            if (checkable && selectable === false) {
                handler.call(dataSet, DataSetEvents.batchSelect, this.handleBatchSelect);
                handler.call(dataSet, DataSetEvents.batchUnSelect, this.handleUnBatchSelect);
            }
        }
    }
    handleDataSetLoad() {
        this.initDefaultExpandedRows();
        this.initDefaultCheckRows();
        this.initDefaultSelectRows();
        this.initDefaultLoadedRows();
    }
    initDefaultExpandedRows() {
        const { props: { defaultExpandAll, dataSet, defaultExpandedKeys, }, } = this;
        this.stateExpandedKeys = this.dealDefaultCheckExpand(dataSet, defaultExpandedKeys, defaultExpandAll);
    }
    initDefaultCheckRows() {
        const { props: { dataSet, checkable, selectable, defaultCheckedKeys, }, } = this;
        this.stateCheckedKeys = this.dealDefaultCheckExpand(dataSet, defaultCheckedKeys);
        if (dataSet) {
            const { checkField, idField } = dataSet.props;
            if (checkable && selectable === false) {
                if (checkField) {
                    const field = dataSet.getField(checkField);
                    dataSet.forEach(record => {
                        if (record.get(checkField) === (field ? field.get(BooleanValue.trueValue, record) : true)) {
                            record.isSelected = true;
                        }
                    });
                }
                else {
                    this.stateCheckedKeys = dataSet.selected.map(selected => String(idField ? selected.get(idField) : selected.id));
                }
            }
        }
    }
    initDefaultLoadedRows() {
        this.stateLoadedKeys = [];
    }
    initDefaultSelectRows() {
        const { props: { dataSet, defaultSelectedKeys, }, } = this;
        if (dataSet && (defaultSelectedKeys)) {
            const { idField } = dataSet.props;
            defaultSelectedKeys.map(selectKey => {
                const found = dataSet.find(record => selectKey === String(idField ? record.get(idField) : record.id));
                if (found) {
                    dataSet.select(found);
                }
                return null;
            });
        }
    }
    /**
     * 处理tree的props expand check的默认事件
     * @param dataSet
     * @param defaultAll
     * @param defaultKeys
     */
    dealDefaultCheckExpand(dataSet, defaultKeys, defaultAll) {
        let defaultStateKeys = [];
        if (dataSet) {
            const { idField, expandField } = dataSet.props;
            if (defaultAll && !expandField) {
                defaultStateKeys = dataSet.reduce((array, record) => {
                    if (record.children) {
                        array.push(getKey(record, idField));
                    }
                    return array;
                }, []);
            }
            else if (defaultKeys && !expandField) {
                defaultStateKeys = dataSet.reduce((array, record) => {
                    defaultKeys.map((key) => {
                        if (getKey(record, idField) === key) {
                            array.push(key);
                        }
                        return null;
                    });
                    return array;
                }, []);
            }
        }
        return defaultStateKeys;
    }
    get expandedKeys() {
        const { dataSet } = this.props;
        if (dataSet) {
            const { expandField, idField } = dataSet.props;
            if (expandField) {
                const keys = [];
                dataSet.forEach(record => {
                    if (record.isExpanded) {
                        keys.push(getKey(record, idField));
                    }
                });
                return keys;
            }
        }
        return this.stateExpandedKeys;
    }
    get checkedKeys() {
        const { dataSet } = this.props;
        if (dataSet) {
            const { checkField, idField } = dataSet.props;
            if (checkField) {
                const keys = [];
                const field = dataSet.getField(checkField);
                dataSet.forEach(record => {
                    const key = getKey(record, idField);
                    if (record.get(checkField) === (field ? field.get(BooleanValue.trueValue, record) : true)) {
                        keys.push(key);
                    }
                });
                return keys;
            }
        }
        return this.stateCheckedKeys;
    }
    get selectedKeys() {
        const { dataSet } = this.props;
        if (dataSet) {
            const { idField } = dataSet.props;
            return dataSet.selected.map(record => getKey(record, idField));
        }
        return [];
    }
    get checkStrictly() {
        const { dataSet, checkStrictly } = this.props;
        if (dataSet && !isNil(dataSet.props.treeCheckStrictly)) {
            return dataSet.props.treeCheckStrictly;
        }
        if (dataSet && dataSet.props.checkField) {
            return false;
        }
        return checkStrictly;
    }
    setExpand(eventObj) {
        const { dataSet } = this.props;
        if (dataSet) {
            const { expandField, idField } = dataSet.props;
            if (expandField) {
                const { node, expanded } = eventObj;
                const { eventKey } = node;
                const found = dataSet.find(record => eventKey === getKey(record, idField));
                if (found) {
                    found.isExpanded = !!expanded;
                    return false;
                }
            }
        }
        return true;
    }
    setCheck(eventObj) {
        const { dataSet } = this.props;
        if (dataSet) {
            const { checkField, idField } = dataSet.props;
            if (checkField) {
                const { node, checked } = eventObj;
                const { eventKey } = node;
                const found = dataSet.find(record => eventKey === String(idField ? record.get(idField) : record.id));
                if (found) {
                    const field = dataSet.getField(checkField);
                    found.set(checkField, field ? checked ? field.get(BooleanValue.trueValue, found) : field.get(BooleanValue.falseValue, found) : checked);
                    return false;
                }
            }
        }
        return true;
    }
    handleExpand(expandedKeys, eventObj) {
        if (this.setExpand(eventObj)) {
            runInAction(() => {
                this.stateExpandedKeys = expandedKeys;
            });
        }
        const { onExpand = noop } = this.props;
        onExpand(expandedKeys, eventObj);
    }
    handleCheck(checkedKeys, eventObj, oldCheckedKeys) {
        const checkedKeysArr = getCheckedKeys(checkedKeys);
        const oldCheckedKeysArr = getCheckedKeys(oldCheckedKeys);
        this.inCheckExpansion = true;
        const { dataSet, selectable } = this.props;
        if (this.setCheck(eventObj)) {
            runInAction(() => {
                this.stateCheckedKeys = checkedKeysArr;
            });
        }
        if (dataSet && selectable === false) {
            const { idField } = dataSet.props;
            const diffKeys = xor(oldCheckedKeysArr, checkedKeysArr);
            dataSet.forEach(record => {
                diffKeys.forEach((key) => {
                    if (getKey(record, idField) === key) {
                        if (!record.isSelected) {
                            dataSet.select(record);
                        }
                        else {
                            dataSet.unSelect(record);
                        }
                    }
                });
            });
        }
        const { onCheck = noop } = this.props;
        onCheck(checkedKeys, eventObj, oldCheckedKeys);
        this.inCheckExpansion = false;
    }
    handleBatchSelect({ dataSet, records }) {
        this.handleDataSetSelect({ dataSet, records }, true);
    }
    handleUnBatchSelect({ dataSet, records }) {
        this.handleDataSetSelect({ dataSet, records }, false);
    }
    handleDataSetSelect({ dataSet, records }, checked) {
        if (!this.inCheckExpansion) {
            const { checkField, idField } = dataSet.props;
            if (checkField) {
                const field = dataSet.getField(checkField);
                records.forEach((record) => {
                    record.set(checkField, field ? checked ? field.get(BooleanValue.trueValue, record) : field.get(BooleanValue.falseValue, record) : checked);
                });
            }
            else {
                runInAction(() => {
                    this.stateCheckedKeys = dataSet.selected.map(selected => String(idField ? selected.get(idField) : selected.id));
                });
            }
        }
    }
    handleSelect(selectedKeys, eventObj) {
        const { dataSet, onSelect = noop } = this.props;
        if (dataSet) {
            const { idField } = dataSet.props;
            const { node, selected } = eventObj;
            const { eventKey } = node;
            const found = dataSet.find(record => eventKey === String(idField ? record.get(idField) : record.id));
            if (found) {
                if (selected) {
                    dataSet.select(found);
                }
                else {
                    dataSet.unSelect(found);
                }
            }
            onSelect(selectedKeys, eventObj);
        }
    }
    handleLoadData(event) {
        const { dataSet, loadData, async } = this.props;
        const promises = [];
        if (async && dataSet) {
            const { record } = event.props;
            promises.push(dataSet.queryMoreChild(record, dataSet.currentPage));
        }
        if (loadData) {
            promises.push(loadData(event));
        }
        return Promise.all(promises).then(action(() => {
            this.stateLoadedKeys.push(event.key);
            this.handleAfterLoadData(event);
        }));
    }
    handleAfterLoadData(event) {
        const { dataSet, selectable } = this.props;
        if (dataSet && selectable === false) {
            const { checkField, idField } = dataSet.props;
            const loadRootRecord = dataSet.find(record => getKey(record, idField) === String(event.key));
            if (!loadRootRecord) {
                return;
            }
            const loadRecords = defaultTo(loadRootRecord.children, []);
            if (checkField) {
                const field = dataSet.getField(checkField);
                loadRecords.forEach(record => {
                    if (record.get(checkField) === (field ? field.get(BooleanValue.trueValue, record) : true)) {
                        dataSet.select(record);
                    }
                });
                if (!loadRootRecord.isSelected && loadRecords.every(record => record.isSelected)) {
                    dataSet.select(loadRootRecord);
                }
                else if (loadRootRecord.isSelected && loadRecords.some(record => !record.isSelected)) {
                    dataSet.unSelect(loadRootRecord);
                }
            }
            else if (event.checked) {
                loadRecords.forEach(record => {
                    dataSet.select(record);
                });
            }
        }
    }
    render() {
        const { dataSet, renderer = defaultRenderer, titleField, treeNodeRenderer, onTreeNode, loadData, async, selectable, filter: optionsFilter, ...otherProps } = this.props;
        if (dataSet) {
            const props = {};
            props.treeData = getTreeNodes(dataSet, dataSet.treeData, renderer, onTreeNode || treeNodeRenderer || defaultNodeCover, async || !!loadData, titleField, optionsFilter) || [];
            props.onExpand = this.handleExpand;
            props.onCheck = this.handleCheck;
            props.onSelect = this.handleSelect;
            props.selectable = selectable;
            props.loadData = this.handleLoadData;
            props.expandedKeys = this.expandedKeys.slice();
            if (!('checkedKeys' in otherProps)) {
                props.checkedKeys = this.checkedKeys.slice();
            }
            if (!('multiple' in otherProps)) {
                props.multiple = dataSet.props.selection === DataSetSelection.multiple;
            }
            if (!('selectedKeys' in otherProps)) {
                props.selectedKeys = this.selectedKeys.slice();
            }
            if (!('loadedKeys' in otherProps)) {
                props.loadedKeys = this.stateLoadedKeys.slice();
            }
            props.checkStrictly = this.checkStrictly;
            return (React.createElement(Spin, { dataSet: dataSet },
                React.createElement(C7NTree, Object.assign({}, otherProps, props))));
        }
        return React.createElement(C7NTree, Object.assign({}, otherProps));
    }
};
Tree.displayName = 'Tree<PRO>';
Tree.TreeNode = TreeNode;
__decorate([
    observable
], Tree.prototype, "stateCheckedKeys", void 0);
__decorate([
    observable
], Tree.prototype, "stateExpandedKeys", void 0);
__decorate([
    observable
], Tree.prototype, "stateLoadedKeys", void 0);
__decorate([
    autobind
], Tree.prototype, "handleDataSetLoad", null);
__decorate([
    action
], Tree.prototype, "initDefaultExpandedRows", null);
__decorate([
    action
], Tree.prototype, "initDefaultCheckRows", null);
__decorate([
    action
], Tree.prototype, "initDefaultLoadedRows", null);
__decorate([
    action
], Tree.prototype, "initDefaultSelectRows", null);
__decorate([
    computed
], Tree.prototype, "expandedKeys", null);
__decorate([
    computed
], Tree.prototype, "selectedKeys", null);
__decorate([
    autobind
], Tree.prototype, "handleExpand", null);
__decorate([
    autobind
], Tree.prototype, "handleCheck", null);
__decorate([
    autobind
], Tree.prototype, "handleBatchSelect", null);
__decorate([
    autobind
], Tree.prototype, "handleUnBatchSelect", null);
__decorate([
    autobind
], Tree.prototype, "handleDataSetSelect", null);
__decorate([
    autobind
], Tree.prototype, "handleSelect", null);
__decorate([
    autobind
], Tree.prototype, "handleLoadData", null);
__decorate([
    autobind
], Tree.prototype, "handleAfterLoadData", null);
Tree = __decorate([
    observer
], Tree);
export default Tree;
